import { restHeartClient } from '..'

/**
 * 删除文档。
 * @param db
 * @param collection
 * @param id
 */
export function deleteDocumentById(db: string, collection: string, id: string) {
	return restHeartClient.delete(`${db}/${collection}/${id}`)
}
